<template>
<div class="shopping">
    <div class="title">{{ props.promotion?.title }}</div>
    <div class="description">{{ props.promotion?.description }}</div>
    <a
        :href="ctaLink"
        class="sale-button"
        role="button"
    >
        {{ props.promotion?.buttonText }}
        <span><i class="fa-solid fa-arrow-right arrow" /></span>
    </a>
</div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { JBGWeb } from '$types/JBGWeb'
import { combineUtmParams } from '$services/tracking'

const props = defineProps({
    promotion: Object as PropType<JBGWeb.InformationalCta>
})

const ctaLink = computed(() => {
    if (!props.promotion?.ctaLink) return ''

    const url = new URL(props.promotion.ctaLink)

    const route = useRoute()
    combineUtmParams(url, new URLSearchParams(route.query as Record<string, string>))

    return url.href
})

</script>

<style scoped lang="scss">
@use "$styles/kit.scss" as *;

.shopping {
    flex-grow: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-left: 140px;
    margin-right: 12px;

    @media screen and (min-width: 350px) and (max-width: 439px){
        margin-left: 118px;
    }

    @media screen and (min-width: 200px) and (max-width: 350px){
        margin-left: 98px;
    }

    .title {
        margin-top: 12px;
        margin-bottom: 8px;
        font-weight: 700;
        font-size: 16px;
        line-height: 1.1;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        @media screen and (min-width: 200px) and (max-width: 439px){
            margin-top: 10px;
            margin-bottom: 5px;
            font-size: 14px;
        }
    }

    .description {
        margin-bottom: 10px;
        font-size: 14px;
        line-height: normal;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;

        @media screen and (min-width: 200px) and (max-width: 439px){
            margin-bottom: 6px;
            font-size: 12px;
        }
    }

    .sale-button {
        background: linear-gradient(90deg, #9CA7FE 0%, #C0C7FF 100%);
        border-radius: 4px;
        width: 100%;
        max-width: 252px;
        height: 40px;
        display: flex;
        padding: 12px;
        align-items: center;
        justify-content: space-between;
        font-size: 13px;
        line-height: 1;
        font-weight: 500;
        color: var(--neutral-900);
        margin-bottom: 16px;
        border: 1px solid transparent;

        &:hover:not(:disabled) {
            background-color: linear-gradient(90deg, #8B96E6 0%, #B1BAFE 100%);
            border: 1px solid rgba(244, 245, 255, 0.80);
            box-shadow:
                0 0 16px 0 rgba(0, 0, 0, 0.10) inset,
                0 0 4px 0 rgba(176, 185, 253, 0.40),
                0 0 12px 0 rgba(166, 176, 255, 0.32),
                0 0 24px 0 rgba(206, 212, 255, 0.24);
        }

        @media screen and (min-width: 200px) and (max-width: 439px){
            margin-right: 8px;
            min-width: 100px;
            height: 32px;
            font-size: 12px;
        }

        .arrow {
            height: 16px;
            width: 16px;
        }
    }
}

</style>
